import React from 'react';
import { SvgIconProps } from './types';

/**
 * An underlined "A", tinted with the text colour currently applied.
 *
 * Not MUI's FormatColorText: that glyph carries a full-width 4px bar meant to
 * read as a colour swatch, which next to FormatUnderlined looks like a second,
 * heavier underline. This reuses FormatUnderlined's own underline geometry, so
 * the two sit on the same baseline at the same weight.
 *
 * Sized in em rather than through the shared SvgIcon wrapper: Icon passes its
 * `size` down as style.fontSize, but SvgIcon reads a `size`/`fontSize` prop
 * that Icon never forwards and otherwise falls back to a hardcoded 24px — so a
 * wrapped icon renders larger than the MUI glyphs it sits beside.
 */
const TextColorLetter = ({ className, style, ...props }: SvgIconProps) => (
    <svg
        viewBox="0 0 24 24"
        focusable="false"
        className={className}
        style={{ width: '1em', height: '1em', fill: 'currentColor', ...style }}
        {...props}
    >
        {/* FormatColorText draws its A wider than the B, I and U letterforms;
            0.92 about the baseline brings it back to their optical size. */}
        <path
            d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
            transform="translate(12,17) scale(0.92) translate(-12,-17)"
        />
        <path d="M5 19h14v2H5z" />
    </svg>
);

export default TextColorLetter;
